module.exports = __webpack_public_path__ + "static/media/Jamaika-White-Flat.00f3b1b8.png";